<template>
  <div id="BarzahlenModal">
    <b-modal ref="barzahlenModal" hide-footer hide-header size="md">
      <div class="d-block">
        <b-container>
          <b-row>
            <b-col class="font-weight-bold"> Bitte E-Mail oder Mobilnummer zur Übermittlung des Zahlungsbelegs angeben </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col class="ml-1">Kontaktart:</b-col>
          </b-row>
          <b-row>
            <b-col><b-form-select v-model="selected" :options="options" size="sm" @change="changeQualifier"></b-form-select></b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col class="ml-1">{{ contactKind}}:</b-col>
          </b-row>
          <b-row>
            <b-col><b-form-input v-model="contact" :placeholder="contactKind" size="sm" @keyup.enter="startPayment" @change="validateData"></b-form-input></b-col>
          </b-row>
          <b-row class="mt-2 text-danger" v-if="msg">
            <b-col>{{ msg }}</b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col><b-button size="sm" @click="startPayment">Zahlungsbeleg anfordern</b-button></b-col>
          </b-row>
        </b-container>
      </div>

    </b-modal>
  </div>
</template>

<script>

export default {
  name: 'BarzahlenModal',
  components: { },
  created: function () {
  },
  data () {
    return {
      selected: 'email',
      options: [
        { value: 'email', text: 'E-Mail' },
        { value: 'fon', text: 'SMS' }
      ],
      contactKind: 'E-Mail',
      contact: null,
      msg: null
    }
  },
  methods: {
    startPayment () {
      this.msg = ''
      if (!this.contact) {
        this.msg = 'Bitte ' + this.contactKind + ' angeben.'
      } else {
        if (this.validateData()) {
          if (localStorage.custNo) {
            this.$emit('pay', this.selected, this.contact)
          } else {
            alert('Customer not found')
            // this.$router.replace({ name: 'start' })
          }
        }
      }
    },
    validateData () {
      // eslint-disable-next-line no-control-regex
      let regexMail = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
      let regexMobil = /^\+[0-9]{9,19}$/
      if (!this.contact) {
        this.msg = 'Bitte ' + this.contactKind + ' angeben.'
        return false
      } else {
        if (this.selected === 'fon') {
          if (!this.contact.match(regexMobil)) {
            this.msg = 'Bitte Mobilnummer im internationalen Format angeben. Beispiel: +4916012345678'
            return false
          }
        } else {
          if (!this.contact.match(regexMail)) {
            this.msg = 'Bitte eine gültige E-Mail-Adresse angeben.'
            return false
          }
        }
      }
      this.msg = ''
      return true
    },
    changeQualifier () {
      if (this.selected === 'fon') {
        this.contactKind = 'Mobilnummer'
      } else {
        this.contactKind = 'E-Mail'
      }
    },
    show () {
      this.$refs['barzahlenModal'].show()
    },
    hide () {
      this.$refs['barzahlenModal'].hide()
    }
  }
}
</script>
